import styled, { css } from 'styled-components';

import { DOT_HORIZONTAL_MARGIN, DOT_WIDTH, HALF_LINE_HEIGHT, LINE_HEIGHT } from './constants';

export const CheckoutErrorCellContainer = styled.div<{ $gridVariant?: boolean }>`
  width: 100%;
  text-align: center;

  ${({ $gridVariant }) =>
    $gridVariant &&
    css`
      display: grid;
      grid-template-columns: ${DOT_HORIZONTAL_MARGIN * 2 + DOT_WIDTH}rem 1fr;
      text-align: left;
    `}

  margin: 1rem 0 0 0;
  :last-child {
    margin-bottom: 0;
  }
`;

export const Dot = styled.div`
  margin: ${HALF_LINE_HEIGHT}rem ${DOT_HORIZONTAL_MARGIN}rem;
  height: 0.25rem;
  width: ${DOT_WIDTH}rem;
  background-color: ${Styles.color.black};
  border-radius: 50%;
  display: inline-block;
`;

export const ErrorText = styled.span`
  line-height: ${LINE_HEIGHT}rem;
`;
